// extracted by mini-css-extract-plugin
export default {"tableTopRow":"styles_tableTopRow__1ztEB","insightToggleSvg":"styles_insightToggleSvg__iUueo","insightRow":"styles_insightRow__Le6MF","insightColumn":"styles_insightColumn__zW2Wm"};